import type {
    FC
} from "react";
import type {
    BlockViewport
} from "./settings";
import Billing01 from "./billing01";
import billing01Source from "./billing01?raw";
import Blog01 from "./blog01";
import blog01Source from "./blog01?raw";
import Booking01 from "./booking01";
import booking01Source from "./booking01?raw";
import Changelog01 from "./changelog01";
import changelog01Source from "./changelog01?raw";
import Chat01 from "./chat01";
import chat01Source from "./chat01?raw";
import Checkout01 from "./checkout01";
import checkout01Source from "./checkout01?raw";
import Course01 from "./course01";
import course01Source from "./course01?raw";
import Dashboard01 from "./dashboard01";
import dashboard01Source from "./dashboard01?raw";
import Dashboard02 from "./dashboard02";
import dashboard02Source from "./dashboard02?raw";
import Events01 from "./events01";
import events01Source from "./events01?raw";
import Files01 from "./files01";
import files01Source from "./files01?raw";
import Fitness01 from "./fitness01";
import fitness01Source from "./fitness01?raw";
import Food01 from "./food01";
import food01Source from "./food01?raw";
import Form01 from "./form01";
import form01Source from "./form01?raw";
import Forum01 from "./forum01";
import forum01Source from "./forum01?raw";
import Health01 from "./health01";
import health01Source from "./health01?raw";
import Help01 from "./help01";
import help01Source from "./help01?raw";
import Inbox01 from "./inbox01";
import inbox01Source from "./inbox01?raw";
import Invoice01 from "./invoice01";
import invoice01Source from "./invoice01?raw";
import Landing01 from "./landing01";
import landing01Source from "./landing01?raw";
import Login01 from "./login01";
import login01Source from "./login01?raw";
import Login02 from "./login02";
import login02Source from "./login02?raw";
import Mobile01 from "./mobile01";
import mobile01Source from "./mobile01?raw";
import Mobile02 from "./mobile02";
import mobile02Source from "./mobile02?raw";
import Music01 from "./music01";
import music01Source from "./music01?raw";
import Onboarding01 from "./onboarding01";
import onboarding01Source from "./onboarding01?raw";
import Orders01 from "./orders01";
import orders01Source from "./orders01?raw";
import Product01 from "./product01";
import product01Source from "./product01?raw";
import Profile01 from "./profile01";
import profile01Source from "./profile01?raw";
import Project01 from "./project01";
import project01Source from "./project01?raw";
import RealEstate01 from "./realEstate01";
import realEstate01Source from "./realEstate01?raw";
import Settings01 from "./settings01";
import settings01Source from "./settings01?raw";
import Settings02 from "./settings02";
import settings02Source from "./settings02?raw";
import Signup01 from "./signup01";
import signup01Source from "./signup01?raw";
import SmartHome01 from "./smartHome01";
import smartHome01Source from "./smartHome01?raw";
import Status01 from "./status01";
import status01Source from "./status01?raw";
import Store01 from "./store01";
import store01Source from "./store01?raw";
import Travel01 from "./travel01";
import travel01Source from "./travel01?raw";
import Weather01 from "./weather01";
import weather01Source from "./weather01?raw";

export type BlockCategory = "auth" | "data" | "flow" | "account" | "mobile" | "content" | "commerce" | "services" | "community" | "consumer";

export type BlockEntry = {
    viewport?: BlockViewport;
    category: BlockCategory;
    themeKey?: string;
    isDraft?: boolean;
    titleKey: string;
    leadKey: string;
    source: string;
    Component: FC;
    id: string;
};

export const BLOCKS: Array<BlockEntry> = [
    {
        titleKey: "blocks.login01.name",
        leadKey: "blocks.login01.lead",
        source: login01Source,
        Component: Login01,
        category: "auth",
        id: "login-01"
    },
    {
        titleKey: "blocks.login02.name",
        leadKey: "blocks.login02.lead",
        source: login02Source,
        Component: Login02,
        category: "auth",
        id: "login-02",
        isDraft: true
    },
    {
        titleKey: "blocks.signup01.name",
        leadKey: "blocks.signup01.lead",
        source: signup01Source,
        Component: Signup01,
        category: "auth",
        id: "signup-01",
        isDraft: true
    },
    {
        titleKey: "blocks.dashboard01.name",
        leadKey: "blocks.dashboard01.lead",
        source: dashboard01Source,
        Component: Dashboard01,
        id: "dashboard-01",
        category: "data"
    },
    {
        titleKey: "blocks.dashboard02.name",
        leadKey: "blocks.dashboard02.lead",
        source: dashboard02Source,
        Component: Dashboard02,
        id: "dashboard-02",
        category: "data",
        isDraft: true
    },
    {
        titleKey: "blocks.orders01.name",
        leadKey: "blocks.orders01.lead",
        source: orders01Source,
        Component: Orders01,
        category: "data",
        id: "orders-01"
    },
    {
        titleKey: "blocks.files01.name",
        leadKey: "blocks.files01.lead",
        source: files01Source,
        Component: Files01,
        category: "data",
        id: "files-01",
        isDraft: true
    },
    {
        titleKey: "blocks.chat01.name",
        leadKey: "blocks.chat01.lead",
        source: chat01Source,
        Component: Chat01,
        category: "flow",
        id: "chat-01"
    },
    {
        titleKey: "blocks.inbox01.name",
        leadKey: "blocks.inbox01.lead",
        source: inbox01Source,
        Component: Inbox01,
        category: "flow",
        id: "inbox-01",
        isDraft: true
    },
    {
        titleKey: "blocks.project01.name",
        leadKey: "blocks.project01.lead",
        source: project01Source,
        Component: Project01,
        category: "flow",
        id: "project-01",
        isDraft: true
    },
    {
        titleKey: "blocks.onboarding01.name",
        leadKey: "blocks.onboarding01.lead",
        source: onboarding01Source,
        Component: Onboarding01,
        id: "onboarding-01",
        category: "flow",
        isDraft: true
    },
    {
        titleKey: "blocks.settings01.name",
        leadKey: "blocks.settings01.lead",
        source: settings01Source,
        Component: Settings01,
        category: "account",
        id: "settings-01"
    },
    {
        titleKey: "blocks.settings02.name",
        leadKey: "blocks.settings02.lead",
        source: settings02Source,
        Component: Settings02,
        category: "account",
        id: "settings-02",
        isDraft: true
    },
    {
        titleKey: "blocks.billing01.name",
        leadKey: "blocks.billing01.lead",
        source: billing01Source,
        Component: Billing01,
        category: "account",
        id: "billing-01",
        isDraft: true
    },
    {
        titleKey: "blocks.booking01.name",
        leadKey: "blocks.booking01.lead",
        source: booking01Source,
        Component: Booking01,
        category: "account",
        id: "booking-01"
    },
    {
        titleKey: "blocks.mobile01.name",
        leadKey: "blocks.mobile01.lead",
        source: mobile01Source,
        Component: Mobile01,
        category: "mobile",
        viewport: "phone",
        id: "mobile-01"
    },
    {
        titleKey: "blocks.mobile02.name",
        leadKey: "blocks.mobile02.lead",
        source: mobile02Source,
        Component: Mobile02,
        category: "mobile",
        viewport: "phone",
        id: "mobile-02",
        isDraft: true
    },
    {
        titleKey: "blocks.landing01.name",
        leadKey: "blocks.landing01.lead",
        source: landing01Source,
        Component: Landing01,
        category: "content",
        id: "landing-01"
    },
    {
        titleKey: "blocks.blog01.name",
        leadKey: "blocks.blog01.lead",
        source: blog01Source,
        category: "content",
        Component: Blog01,
        id: "blog-01"
    },
    {
        titleKey: "blocks.help01.name",
        leadKey: "blocks.help01.lead",
        source: help01Source,
        category: "content",
        Component: Help01,
        isDraft: true,
        id: "help-01"
    },
    {
        titleKey: "blocks.changelog01.name",
        leadKey: "blocks.changelog01.lead",
        source: changelog01Source,
        Component: Changelog01,
        category: "content",
        id: "changelog-01",
        isDraft: true
    },
    {
        titleKey: "blocks.status01.name",
        leadKey: "blocks.status01.lead",
        source: status01Source,
        category: "content",
        Component: Status01,
        id: "status-01",
        isDraft: true
    },
    {
        titleKey: "blocks.store01.name",
        leadKey: "blocks.store01.lead",
        source: store01Source,
        category: "commerce",
        Component: Store01,
        id: "store-01",
        isDraft: true
    },
    {
        titleKey: "blocks.product01.name",
        leadKey: "blocks.product01.lead",
        source: product01Source,
        category: "commerce",
        Component: Product01,
        id: "product-01",
        isDraft: true
    },
    {
        titleKey: "blocks.checkout01.name",
        leadKey: "blocks.checkout01.lead",
        source: checkout01Source,
        Component: Checkout01,
        category: "commerce",
        id: "checkout-01"
    },
    {
        titleKey: "blocks.invoice01.name",
        leadKey: "blocks.invoice01.lead",
        source: invoice01Source,
        category: "commerce",
        Component: Invoice01,
        id: "invoice-01",
        isDraft: true
    },
    {
        titleKey: "blocks.health01.name",
        leadKey: "blocks.health01.lead",
        source: health01Source,
        category: "services",
        Component: Health01,
        id: "health-01",
        isDraft: true
    },
    {
        titleKey: "blocks.course01.name",
        leadKey: "blocks.course01.lead",
        source: course01Source,
        category: "services",
        Component: Course01,
        id: "course-01",
        isDraft: true
    },
    {
        titleKey: "blocks.form01.name",
        leadKey: "blocks.form01.lead",
        category: "services",
        source: form01Source,
        Component: Form01,
        isDraft: true,
        id: "form-01"
    },
    {
        titleKey: "blocks.realEstate01.name",
        leadKey: "blocks.realEstate01.lead",
        source: realEstate01Source,
        Component: RealEstate01,
        category: "community",
        id: "real-estate-01",
        isDraft: true
    },
    {
        titleKey: "blocks.events01.name",
        leadKey: "blocks.events01.lead",
        source: events01Source,
        category: "community",
        Component: Events01,
        id: "events-01",
        isDraft: true
    },
    {
        titleKey: "blocks.profile01.name",
        leadKey: "blocks.profile01.lead",
        source: profile01Source,
        category: "community",
        Component: Profile01,
        id: "profile-01",
        isDraft: true
    },
    {
        titleKey: "blocks.forum01.name",
        leadKey: "blocks.forum01.lead",
        category: "community",
        source: forum01Source,
        Component: Forum01,
        id: "forum-01",
        isDraft: true
    },
    {
        titleKey: "blocks.smartHome01.name",
        leadKey: "blocks.smartHome01.lead",
        source: smartHome01Source,
        Component: SmartHome01,
        category: "consumer",
        id: "smart-home-01",
        viewport: "tablet",
        isDraft: true
    },
    {
        titleKey: "blocks.music01.name",
        leadKey: "blocks.music01.lead",
        source: music01Source,
        category: "consumer",
        Component: Music01,
        viewport: "phone",
        themeKey: "dark",
        id: "music-01",
        isDraft: true
    },
    {
        titleKey: "blocks.fitness01.name",
        leadKey: "blocks.fitness01.lead",
        source: fitness01Source,
        category: "consumer",
        Component: Fitness01,
        viewport: "phone",
        id: "fitness-01",
        isDraft: true
    },
    {
        titleKey: "blocks.food01.name",
        leadKey: "blocks.food01.lead",
        category: "consumer",
        source: food01Source,
        Component: Food01,
        viewport: "phone",
        isDraft: true,
        id: "food-01"
    },
    {
        titleKey: "blocks.travel01.name",
        leadKey: "blocks.travel01.lead",
        source: travel01Source,
        category: "consumer",
        Component: Travel01,
        viewport: "phone",
        id: "travel-01",
        isDraft: true
    },
    {
        titleKey: "blocks.weather01.name",
        leadKey: "blocks.weather01.lead",
        source: weather01Source,
        category: "consumer",
        Component: Weather01,
        viewport: "phone",
        id: "weather-01",
        isDraft: true
    }
];

export const BLOCK_CATEGORIES: Array<BlockCategory> = [
    "auth",
    "data",
    "flow",
    "account",
    "mobile",
    "content",
    "commerce",
    "services",
    "community",
    "consumer"
];

export const PUBLISHED_BLOCKS = BLOCKS.filter((block) => !block.isDraft);

export const PUBLISHED_BLOCK_CATEGORIES = BLOCK_CATEGORIES.filter((category) => PUBLISHED_BLOCKS.some((block) => block.category === category));

export const BLOCKS_PATH = "/blocks";

export const getBlockPath = (id: string) => `${BLOCKS_PATH}/${id}`;

export const isBlocksPath = (path: string) => path === BLOCKS_PATH || path.startsWith(`${BLOCKS_PATH}/`);

export const findBlock = (id: string) => BLOCKS.find((block) => block.id === id);
